import React, { useMemo, useRef, useState} from 'react';
import {AgGridReact} from "ag-grid-react";
import {Modal} from "../../../../../../../../components/modal/modal.jsx";
import aggridUtils from "../../../../../../../../utils/aggrid-utils.js";
import Button from "../../../../../../../../components/button/button.jsx";
import projectUtils from "../../../../../../../../utils/project-utils.js";
import {formatIsoDate} from "../../../utils/work-schedule-utils.js";

const ModalConflictsResolution = ({open, setOpen, id, updateTableWithNoReplace, updateTable, availableEffectives, conflictDefaultColDef}) => {
    const tableRef = useRef(null);

    const [columnDefs,] = useState([
        {headerName: "Nome", field: "name", flex: 1, filter: true},
        {headerName: "Equipe", field: "teamName", filter: true},
        {
            headerName: "Final da escala anterior", field: "beforeDate",
            valueGetter: params => params.data.beforeDate ? formatIsoDate(params.data.beforeDate) : ""
        },
        {
            headerName: "Início da próxima escala", field: "afterDate",
            valueGetter: params => params.data.afterDate ? formatIsoDate(params.data.afterDate) : ""
        }
    ]);
    const [currentDataSelected, setCurrentDataSelected] = useState(null);

    const onRowClicked = (row) => {
        const {node, data} = row
        node.setSelected(true);
        setCurrentDataSelected(data);
    }

    const closeModal = () => {
        setOpen(false);
    };

    return (
        <Modal open={open} setOpen={setOpen} title={"Substituição de efetivos"}>
            <Modal.Body>
                <div style={{height: "calc(100vh - 290px"}} className={"aggrid-row-pointer"}>
                    <AgGridReact
                        ref={tableRef}
                        rowData={availableEffectives.find(el => el.id === id).availableEffective ?? []}
                        columnDefs={columnDefs}
                        defaultColDef={conflictDefaultColDef}
                        animateRows={false}
                        suppressCellFocus={true}
                        onRowClicked={onRowClicked}
                        rowSelection={{
                            mode: 'singleRow',
                            checkboxes: false,
                            headerCheckbox: false,
                            enableClickSelection: true
                        }}
                        theme={aggridUtils.generalTheme({rowHeight: 40, headerHeight: 40})}
                        gridOptions={{localeText: aggridUtils.localization()}}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="flex justify-end gap-2">
                    <Button target="danger" onClick={() => {
                        updateTableWithNoReplace([id]);
                        closeModal();
                    }} >Não substituir efetivo</Button>
                    <Button target="success" disabled={!currentDataSelected} onClick={(e) => {
                        updateTable(currentDataSelected, [id]);
                        closeModal();
                    }}>Substituir efetivo</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalConflictsResolution;